import React from 'react';
import { AlertOctagon, ChevronRight, Send, XCircle } from 'lucide-react';
import { Button } from '../ui/button';
import { aud, fmtDate, freqLabel } from './utils';

const Reason = ({ p }) =>
  p.overdue_reason === 'failed' ? (
    <span className="flex items-center gap-1.5"><XCircle className="h-4 w-4" />Failed payment on {fmtDate(p.last_failed_date)}</span>
  ) : (
    <span>Missed {aud(p.next_due_amount)} due {fmtDate(p.next_due)} · {p.days_overdue} day{p.days_overdue === 1 ? '' : 's'} overdue</span>
  );

export const FollowUpList = ({ plans, onFollowUp, onOpen }) => {
  if (!plans.length) return null;
  return (
    <section className="space-y-3" data-testid="follow-up-section">
      <div className="flex items-center gap-2">
        <AlertOctagon className="h-5 w-5 text-[#C0392B]" />
        <h2 className="font-heading text-xl font-semibold text-[#3A3530]">Needs follow-up</h2>
        <span className="rounded-full bg-[#C0392B] px-2 py-0.5 text-xs font-bold text-white" data-testid="follow-up-count">{plans.length}</span>
      </div>
      <div className="grid gap-3 md:grid-cols-2">
        {plans.map((p) => (
          <div key={p.id} className="pp-glow-red flex flex-col gap-3 rounded-2xl border border-[#C0392B]/50 bg-[#FFF5F3] p-4 sm:flex-row sm:items-center"
            data-testid={`follow-up-card-${p.id}`}>
            <div className="min-w-0 flex-1">
              <p className="truncate font-semibold text-[#3A3530]">{p.client_name}</p>
              <p className="mt-0.5 text-sm font-medium text-[#C0392B]"><Reason p={p} /></p>
              <p className="mt-1 text-xs text-[#6B6560]">
                {aud(p.instalment_amount)} {freqLabel(p).toLowerCase()} · Balance {aud(p.balance)} · Last paid {fmtDate(p.last_payment_date)}{p.last_payment_amount ? ` (${aud(p.last_payment_amount)})` : ''}
              </p>
            </div>
            <div className="flex gap-2">
              <Button size="sm" onClick={() => onFollowUp(p)} className="bg-[#C0392B] text-white hover:bg-[#A93226]"
                data-testid={`follow-up-send-btn-${p.id}`}>
                <Send className="mr-1.5 h-3.5 w-3.5" />Follow-up sent
              </Button>
              <Button size="sm" variant="ghost" onClick={() => onOpen(p)} className="text-[#6B6560]" data-testid={`follow-up-open-btn-${p.id}`}>
                <ChevronRight className="h-4 w-4" />
              </Button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
